import { userEndPoint, offersEndpoint, offersEndpointWithUser } from './endpoints';

export const getUser = (jwt) =>
  fetch(userEndPoint, {
    headers: {
      Authorization: 'Bearer ' + jwt,
    },
  })
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(response.status);
      }
      return response;
    })
    .then((response) => response.json());

export const getOffers = () =>
  fetch(offersEndpoint, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((response) => response.json());

export const getOffersWithUser = (jwt) =>
  fetch(offersEndpointWithUser, {
    headers: {
      Authorization: 'Bearer ' + jwt,
    },
  }).then((response) => response.json());
